import { AbstractViewModel } from '../../utils/viewmodels/viewmodel';

export type ConfirmModalState = {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
};

export type ConfirmModalConfig = {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
};

export class ConfirmModalViewModel extends AbstractViewModel<ConfirmModalState> {
  static initialState: ConfirmModalState = {
    isOpen: false,
    title: '',
    message: '',
    confirmLabel: 'Bevestigen',
    cancelLabel: 'Annuleren',
  };

  private onConfirmHandler: (() => void) | null = null;
  private onCancelHandler: (() => void) | null = null;

  constructor() {
    super(ConfirmModalViewModel.initialState);

    this.confirm = this.confirm.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  open(config: ConfirmModalConfig) {
    this.onConfirmHandler = config.onConfirm;
    this.onCancelHandler = config.onCancel ?? null;

    this.update((state) => {
      state.isOpen = true;
      state.title = config.title;
      state.message = config.message;
      state.confirmLabel = config.confirmLabel ?? 'Bevestigen';
      state.cancelLabel = config.cancelLabel ?? 'Annuleren';
    });
  }

  confirm() {
    this.onConfirmHandler?.();
    this.close();
  }

  cancel() {
    this.onCancelHandler?.();
    this.close();
  }

  private close() {
    this.onConfirmHandler = null;
    this.onCancelHandler = null;
    this.update((state) => {
      state.isOpen = false;
    });
  }
}
